module.exports = __webpack_public_path__ + "img/ic_trash_black.f6ea63d0.svg";